<template>
  <v-text-field
    v-model="localValue"
    class="textCard__text-field"
    :prepend-icon="prependIcon"
    :rules="numberRules()"
    :label="label"
    :hint="hint"
    type="number"
  />
</template>

<script>
export default {
  name: "IntField",
  props: {
    value: {
      type: Number,
      default: ""
    },
    prependIcon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: null
    },
    extendRules: {
      type: Array,
      default: null
    },
    notNull: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      localValue: this.notNull ? 0 : null,
      defaultRules: [
        (v) =>
          (isNaN(v) && !v) || v === null || !isNaN(v) || "Укажите число",
        (v) =>
          (isNaN(v) && !v) ||
          v === null ||
          v < 2147483647 ||
          "Число слишком большое",
        (v) =>
          (isNaN(v) && !v) ||
          v === null ||
          v > -2147483648 ||
          "Число слишком маленькое"
      ]
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if(!this.value && this.notNull){
          this.localValue = 0;
          return;
        }
        if(this.value && (!isNaN(this.value))){
          this.localValue = this.value;
          return;
        }
        this.localValue = this.notNull ? 0 : null;
      }
    },
    localValue() {
      if (isNaN(this.localValue)) {
        if (!this.localValue){
          if (this.notNull) this.$emit("input", 0);
          else this.$emit("input", null);
        }
        return;
      }
      this.$emit("input", parseInt(this.localValue));
    }
  },
  methods: {
    numberRules() {
      const rules = !this.rules
        ? this.defaultRules
        : this.rules;
      return this.extendRules ? rules.concat(this.extendRules) : rules;
    }
  }
};
</script>

<style scoped></style>
